import { setShareboxFilters, useShareboxFilters } from "modules/ShareboxDashboard/components/ShareboxDashboardTable/hooks";
import { PAGE_SIZE } from "utils/common";

import type { OnChangeFn, PaginationState } from "@tanstack/react-table";

export const useShareboxFilterHandlers = () => {
  const { data: page } = useShareboxFilters();

  const handlePaginationChange: OnChangeFn<PaginationState> = updater => {
    const newState = typeof updater === "function" ? updater({ pageIndex: page, pageSize: PAGE_SIZE.PageSize100 }) : updater;
    setShareboxFilters(newState.pageIndex + 1);
  };

  return handlePaginationChange;
};
